import { render, staticRenderFns } from "./UserActivation.vue?vue&type=template&id=e063a24c"
import script from "./UserActivation.vue?vue&type=script&lang=js"
export * from "./UserActivation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports